import { useEffect, useState } from 'preact/hooks';
import { PerformanceSingleVideoConfig } from '../../../performance-single-video/creative/config';
import { changes } from '../../subs';
import { Change, PreviewEnvironment } from '../../types';
import { useAdParameters } from './useAdParameters';

export function useShowEndScreen() {
  const { config, preview } = useAdParameters<PerformanceSingleVideoConfig>();
  const [showEndScreen, setShowEndScreen] = useState(false);

  useEffect(() => {
    if (config.end_screen?.uri) {
      const fn = (change: Change) => {
        if (change.event === 'stop') {
          setShowEndScreen(true);
        }
      };
      changes.subscribe(fn);

      return () => {
        changes.unsubscribe(fn);
      };
    }
  }, []);

  useEffect(() => {
    if (preview?.previewType !== PreviewEnvironment.CTV) {
      setShowEndScreen(preview?.showEndScreen);
    }
  }, [preview?.showEndScreen, preview?.previewType]);

  return showEndScreen;
}
